function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "a",
  d: "M1413.57 34.2c-.24-.3-.62-.46-1.02-.46h-14.02l-.45-3.1c-.09-.58-.63-1.02-1.27-1.02h-3.37c-.7 0-1.27.53-1.27 1.17 0 .64.57 1.16 1.27 1.16h2.26l2.1 14.41c.08.58.62 1.01 1.26 1.01h10.12c.7 0 1.27-.52 1.27-1.16 0-.64-.57-1.17-1.27-1.17h-9l-.26-1.78h10.38c.57 0 1.07-.34 1.23-.84l2.24-7.2c.11-.35.04-.73-.2-1.02zm-2.65 16.5a1.67 1.67 0 10-3.33 0 1.67 1.67 0 003.33 0zm-10 0a1.67 1.67 0 10-3.33 0 1.67 1.67 0 003.33 0zM1423 41a20 20 0 11-40 0 20 20 0 0140 0zm-24.13-4.93h12l-1.52 4.85h-9.77z"
}));

var _ref2 = /*#__PURE__*/React.createElement("use", {
  fill: "#f5f6f7",
  xlinkHref: "#a",
  transform: "translate(-1383 -21)"
});

var SvgIconCart = function SvgIconCart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "assets/icon-cart.dedf992e.svg";
export { SvgIconCart as ReactComponent };